import React from 'react';
import type {IndicatorLegendItem} from './dcaIndicatorUtil';

interface Props {
    /** 条件涉及的技术指标图例项（带周期） */
    items: IndicatorLegendItem[];
    /** 各指标显隐状态（visibleKey → hidden） */
    hidden: Record<string, boolean>;
    /** 点击切换某指标显隐 */
    onToggle: (visibleKey: string) => void;
}

/**
 * K线图上方指标图例：展示条件涉及的技术指标标识+周期，点击显隐对应指标。
 * 与 LightweightCandlestickChart 的 visibleIndicators 联动。
 */
const DcaIndicatorLegend: React.FC<Props> = ({items, hidden, onToggle}) => {
    if (items.length === 0) {
        return null;
    }
    return (
        <div className="dca-indicator-legend" role="group" aria-label="技术指标">
            {items.map((item) => {
                const off = Boolean(hidden[item.visibleKey]);
                return (
                    <button
                        key={item.key}
                        type="button"
                        className={`dca-indicator-legend-item${off ? ' is-off' : ''}`}
                        aria-pressed={!off}
                        title={off ? '点击显示' : '点击隐藏'}
                        onClick={() => onToggle(item.visibleKey)}
                    >
                        <span className="dca-indicator-legend-dot" style={{background: item.color}}/>
                        <span>{item.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default DcaIndicatorLegend;
